import { render, staticRenderFns } from "./MailActivity.vue?vue&type=template&id=4fdff0bb"
import script from "./MailActivity.vue?vue&type=script&lang=js"
export * from "./MailActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports